<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.sectorId" hidden/>

        <t-input v-model="form.name" :add-error="error.name" label="Categoria" required/>


        <t-input v-model="form.icon" label="Ícone para utilização em marcações" select :options="iconsFont7"
                 small="Confira opções: <a class='text-dark' href='https://themes-pixeden.com/font-demos/7-stroke/' target='_blank'>https://themes-pixeden.com/font-demos/7-stroke/</a>. - Ícone padrão: <b>pe-7s-map-marker</b>"/>


<!--        <div class="bg-light b-radius d-flex align-items-center justify-content-center p-2 mb-2" style="width: 100px">
          <span v-show="form.icon !== ''" :class="{[form.icon] : true}" style="font-size: 64px;"></span>

        </div>-->


        <t-input v-model="form.color" required color-reduced label="Cor"/>

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ExecutorService from "@/services/modules/agent/Executor.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'SectorForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "sectorId",
      form: {
        sectorId: 0,
        sectorNumber: 0,
        name: "",
        color: "",
        icon: "mapmarker", /*Icone padrão*/
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      executorOptions: [],
      iconsFont7: [

        {value: "adduser", text: "adduser"},
        {value: "airplay", text: "airplay"},
        {value: "alarm", text: "alarm"},
        {value: "album", text: "album"},
        {value: "albums", text: "albums"},
        {value: "anchor", text: "anchor"},
        {value: "angledowncircle", text: "angledownc"},
        {value: "angledown", text: "angledown"},
        {value: "angleleftcircle", text: "angleleftc"},
        {value: "angleleft", text: "angleleft"},
        {value: "anglerightcircle", text: "angleright"},
        {value: "angleright", text: "angleright"},
        {value: "angleupcircle", text: "angleupcir"},
        {value: "angleup", text: "angleup"},
        {value: "arc", text: "arc"},
        {value: "attention", text: "attention"},
        {value: "back2", text: "back2"},
        {value: "back", text: "back"},
        {value: "ball", text: "ball"},
        {value: "bandaid", text: "bandaid"},
        {value: "battery", text: "battery"},
        {value: "bell", text: "bell"},
        {value: "bicycle", text: "bicycle"},
        {value: "bluetooth", text: "bluetooth"},
        {value: "bookmarks", text: "bookmarks"},
        {value: "bottomarrow", text: "bottomarro"},
        {value: "box1", text: "box1"},
        {value: "box2", text: "box2"},
        {value: "browser", text: "browser"},
        {value: "calculator", text: "calculator"},
        {value: "call", text: "call"},
        {value: "camera", text: "camera"},
        {value: "car", text: "car"},
        {value: "cart", text: "cart"},
        {value: "cash", text: "cash"},
        {value: "chat", text: "chat"},
        {value: "check", text: "check"},
        {value: "clock", text: "clock"},
        {value: "closecircle", text: "closecircl"},
        {value: "close", text: "close"},
        {value: "clouddownload", text: "clouddownl"},
        {value: "cloudupload", text: "clouduploa"},
        {value: "cloud", text: "cloud"},
        {value: "coffee", text: "coffee"},
        {value: "comment", text: "comment"},
        {value: "compass", text: "compass"},
        {value: "config", text: "config"},
        {value: "copyfile", text: "copyfile"},
        {value: "credit", text: "credit"},
        {value: "crop", text: "crop"},
        {value: "culture", text: "culture"},
        {value: "cup", text: "cup"},
        {value: "date", text: "date"},
        {value: "deleteuser", text: "deleteuser"},
        {value: "diamond", text: "diamond"},
        {value: "disk", text: "disk"},
        {value: "diskette", text: "diskette"},
        {value: "display1", text: "display1"},
        {value: "display2", text: "display2"},
        {value: "doorlock", text: "doorlock"},
        {value: "download", text: "download"},
        {value: "drawer", text: "drawer"},
        {value: "drop", text: "drop"},
        {value: "edit", text: "edit"},
        {value: "exapnd2", text: "exapnd2"},
        {value: "expand1", text: "expand1"},
        {value: "eyedropper", text: "eyedropper"},
        {value: "female", text: "female"},
        {value: "file", text: "file"},
        {value: "film", text: "film"},
        {value: "flag", text: "flag"},
        {value: "folder", text: "folder"},
        {value: "gift", text: "gift"},
        {value: "glasses", text: "glasses"},
        {value: "gleam", text: "gleam"},
        {value: "global", text: "global"},
        {value: "graph", text: "graph"},
        {value: "graph1", text: "graph1"},
        {value: "graph2", text: "graph2"},
        {value: "graph3", text: "graph3"},
        {value: "gym", text: "gym"},
        {value: "hammer", text: "hammer"},
        {value: "headphones", text: "headphones"},
        {value: "helm", text: "helm"},
        {value: "help1", text: "help1"},
        {value: "help2", text: "help2"},
        {value: "home", text: "home"},
        {value: "hourglass", text: "hourglass"},
        {value: "id", text: "id"},
        {value: "info", text: "info"},
        {value: "joy", text: "joy"},
        {value: "junk", text: "junk"},
        {value: "key", text: "key"},
        {value: "keypad", text: "keypad"},
        {value: "leaf", text: "leaf"},
        {value: "leftarrow", text: "leftarrow"},
        {value: "less", text: "less"},
        {value: "light", text: "light"},
        {value: "like", text: "like"},
        {value: "like2", text: "like2"},
        {value: "link", text: "link"},
        {value: "lintern", text: "lintern"},
        {value: "lock", text: "lock"},
        {value: "look", text: "look"},
        {value: "loop", text: "loop"},
        {value: "magicwand", text: "magicwand"},
        {value: "magnet", text: "magnet"},
        {value: "mailopenfile", text: "mailopenfi"},
        {value: "mailopen", text: "mailopen"},
        {value: "mail", text: "mail"},
        {value: "male", text: "male"},
        {value: "map2", text: "map2"},
        {value: "mapmarker", text: "mapmarker"},
        {value: "map", text: "map"},
        {value: "medal", text: "medal"},
        {value: "menu", text: "menu"},
        {value: "micro", text: "micro"},
        {value: "monitor", text: "monitor"},
        {value: "moon", text: "moon"},
        {value: "more", text: "more"},
        {value: "mouse", text: "mouse"},
        {value: "music", text: "music"},
        {value: "musiclist", text: "musiclist"},
        {value: "mute", text: "mute"},
        {value: "network", text: "network"},
        {value: "newspaper", text: "newspaper"},
        {value: "next2", text: "next2"},
        {value: "next", text: "next"},
        {value: "note", text: "note"},
        {value: "note2", text: "note2"},
        {value: "notebook", text: "notebook"},
        {value: "paintbucket", text: "paintbucke"},
        {value: "paint", text: "paint"},
        {value: "paperplane", text: "paperplane"},
        {value: "paperclip", text: "paperclip"},
        {value: "pen", text: "pen"},
        {value: "pendrive", text: "pendrive"},
        {value: "phone", text: "phone"},
        {value: "photogallery", text: "photogalle"},
        {value: "photo", text: "photo"},
        {value: "piggy", text: "piggy"},
        {value: "pin", text: "pin"},
        {value: "plane", text: "plane"},
        {value: "play", text: "play"},
        {value: "plugin", text: "plugin"},
        {value: "plus", text: "plus"},
        {value: "power", text: "power"},
        {value: "prev", text: "prev"},
        {value: "print", text: "print"},
        {value: "radio", text: "radio"},
        {value: "refresh2", text: "refresh2"},
        {value: "refreshcloud", text: "refreshclo"},
        {value: "refresh", text: "refresh"},
        {value: "repeat", text: "repeat"},
        {value: "ribbon", text: "ribbon"},
        {value: "rightarrow", text: "rightarrow"},
        {value: "rocket", text: "rocket"},
        {value: "safe", text: "safe"},
        {value: "science", text: "science"},
        {value: "scissors", text: "scissors"},
        {value: "search", text: "search"},
        {value: "server", text: "server"},
        {value: "settings", text: "settings"},
        {value: "share", text: "share"},
        {value: "shield", text: "shield"},
        {value: "shopbag", text: "shopbag"},
        {value: "shuffle", text: "shuffle"},
        {value: "signal", text: "signal"},
        {value: "smile", text: "smile"},
        {value: "speaker", text: "speaker"},
        {value: "star", text: "star"},
        {value: "stopwatch", text: "stopwatch"},
        {value: "study", text: "study"},
        {value: "sun", text: "sun"},
        {value: "switch", text: "switch"},
        {value: "target", text: "target"},
        {value: "ticket", text: "ticket"},
        {value: "timer", text: "timer"},
        {value: "tools", text: "tools"},
        {value: "trash", text: "trash"},
        {value: "umbrella", text: "umbrella"},
        {value: "unlock", text: "unlock"},
        {value: "uparrow", text: "uparrow"},
        {value: "upload", text: "upload"},
        {value: "usb", text: "usb"},
        {value: "userfemale", text: "userfemale"},
        {value: "user", text: "user"},
        {value: "vector", text: "vector"},
        {value: "video", text: "video"},
        {value: "voicemail", text: "voicemail"},
        {value: "volume", text: "volume"},
        {value: "volume1", text: "volume1"},
        {value: "volume2", text: "volume2"},
        {value: "wallet", text: "wallet"},
        {value: "wine", text: "wine"},
        {value: "world", text: "world"},
        {value: "wristwatch", text: "wristwatch"},
        /* {value: "pe-7s-album", text: "pe-7s-album"},
         {value: "pe-7s-arc", text: "pe-7s-arc"},
         {value: "pe-7s-back-2", text: "pe-7s-back-2"},
         {value: "pe-7s-bandaid", text: "pe-7s-bandaid"},
         {value: "pe-7s-car", text: "pe-7s-car"},
         {value: "pe-7s-diamond", text: "pe-7s-diamond"},
         {value: "pe-7s-door-lock", text: "pe-7s-door-lock"},
         {value: "pe-7s-eyedropper", text: "pe-7s-eyedropper"},
         {value: "pe-7s-female", text: "pe-7s-female"},
         {value: "pe-7s-gym", text: "pe-7s-gym"},
         {value: "pe-7s-hammer", text: "pe-7s-hammer"},
         {value: "pe-7s-headphones", text: "pe-7s-headphones"},
         {value: "pe-7s-helm", text: "pe-7s-helm"},
         {value: "pe-7s-hourglass", text: "pe-7s-hourglass"},
         {value: "pe-7s-leaf", text: "pe-7s-leaf"},
         {value: "pe-7s-magic-wand", text: "pe-7s-magic-wand"},
         {value: "pe-7s-male", text: "pe-7s-male"},
         {value: "pe-7s-map-2", text: "pe-7s-map-2"},
         {value: "pe-7s-next-2", text: "pe-7s-next-2"},
         {value: "pe-7s-paint-bucket", text: "pe-7s-paint-bucket"},
         {value: "pe-7s-pendrive", text: "pe-7s-pendrive"},
         {value: "pe-7s-photo", text: "pe-7s-photo"},
         {value: "pe-7s-piggy", text: "pe-7s-piggy"},
         {value: "pe-7s-plugin", text: "pe-7s-plugin"},
         {value: "pe-7s-refresh-2", text: "pe-7s-refresh-2"},
         {value: "pe-7s-rocket", text: "pe-7s-rocket"},
         {value: "pe-7s-settings", text: "pe-7s-settings"},
         {value: "pe-7s-shield", text: "pe-7s-shield"},
         {value: "pe-7s-smile", text: "pe-7s-smile"},
         {value: "pe-7s-usb", text: "pe-7s-usb"},
         {value: "pe-7s-vector", text: "pe-7s-vector"},
         {value: "pe-7s-wine", text: "pe-7s-wine"},
         {value: "pe-7s-cloud-upload", text: "pe-7s-cloud-upload"},
         {value: "pe-7s-cash", text: "pe-7s-cash"},
         {value: "pe-7s-close", text: "pe-7s-close"},
         {value: "pe-7s-bluetooth", text: "pe-7s-bluetooth"},
         {value: "pe-7s-cloud-download", text: "pe-7s-cloud-download"},
         {value: "pe-7s-way", text: "pe-7s-way"},
         {value: "pe-7s-close-circle", text: "pe-7s-close-circle"},
         {value: "pe-7s-id", text: "pe-7s-id"},
         {value: "pe-7s-angle-up", text: "pe-7s-angle-up"},
         {value: "pe-7s-wristwatch", text: "pe-7s-wristwatch"},
         {value: "pe-7s-angle-up-circle", text: "pe-7s-angle-up-circle"},
         {value: "pe-7s-world", text: "pe-7s-world"},
         {value: "pe-7s-angle-right", text: "pe-7s-angle-right"},
         {value: "pe-7s-volume", text: "pe-7s-volume"},
         {value: "pe-7s-angle-right-circle", text: "pe-7s-angle-right-circle"},
         {value: "pe-7s-users", text: "pe-7s-users"},
         {value: "pe-7s-angle-left", text: "pe-7s-angle-left"},
         {value: "pe-7s-user-female", text: "pe-7s-user-female"},
         {value: "pe-7s-angle-left-circle", text: "pe-7s-angle-left-circle"},
         {value: "pe-7s-up-arrow", text: "pe-7s-up-arrow"},
         {value: "pe-7s-angle-down", text: "pe-7s-angle-down"},
         {value: "pe-7s-switch", text: "pe-7s-switch"},
         {value: "pe-7s-angle-down-circle", text: "pe-7s-angle-down-circle"},
         {value: "pe-7s-scissors", text: "pe-7s-scissors"},
         {value: "pe-7s-wallet", text: "pe-7s-wallet"},
         {value: "pe-7s-safe", text: "pe-7s-safe"},
         {value: "pe-7s-volume2", text: "pe-7s-volume2"},
         {value: "pe-7s-volume1", text: "pe-7s-volume1"},
         {value: "pe-7s-voicemail", text: "pe-7s-voicemail"},
         {value: "pe-7s-video", text: "pe-7s-video"},
         {value: "pe-7s-user", text: "pe-7s-user"},
         {value: "pe-7s-upload", text: "pe-7s-upload"},
         {value: "pe-7s-unlock", text: "pe-7s-unlock"},
         {value: "pe-7s-umbrella", text: "pe-7s-umbrella"},
         {value: "pe-7s-trash", text: "pe-7s-trash"},
         {value: "pe-7s-tools", text: "pe-7s-tools"},
         {value: "pe-7s-timer", text: "pe-7s-timer"},
         {value: "pe-7s-ticket", text: "pe-7s-ticket"},
         {value: "pe-7s-target", text: "pe-7s-target"},
         {value: "pe-7s-sun", text: "pe-7s-sun"},
         {value: "pe-7s-study", text: "pe-7s-study"},
         {value: "pe-7s-stopwatch", text: "pe-7s-stopwatch"},
         {value: "pe-7s-star", text: "pe-7s-star"},
         {value: "pe-7s-speaker", text: "pe-7s-speaker"},
         {value: "pe-7s-signal", text: "pe-7s-signal"},
         {value: "pe-7s-shuffle", text: "pe-7s-shuffle"},
         {value: "pe-7s-shopbag", text: "pe-7s-shopbag"},
         {value: "pe-7s-share", text: "pe-7s-share"},
         {value: "pe-7s-server", text: "pe-7s-server"},
         {value: "pe-7s-search", text: "pe-7s-search"},
         {value: "pe-7s-film", text: "pe-7s-film"},
         {value: "pe-7s-science", text: "pe-7s-science"},
         {value: "pe-7s-disk", text: "pe-7s-disk"},
         {value: "pe-7s-ribbon", text: "pe-7s-ribbon"},
         {value: "pe-7s-repeat", text: "pe-7s-repeat"},
         {value: "pe-7s-refresh", text: "pe-7s-refresh"},
         {value: "pe-7s-add-user", text: "pe-7s-add-user"},
         {value: "pe-7s-refresh-cloud", text: "pe-7s-refresh-cloud"},
         {value: "pe-7s-paperclip", text: "pe-7s-paperclip"},
         {value: "pe-7s-radio", text: "pe-7s-radio"},
         {value: "pe-7s-note2", text: "pe-7s-note2"},
         {value: "pe-7s-print", text: "pe-7s-print"},
         {value: "pe-7s-network", text: "pe-7s-network"},
         {value: "pe-7s-prev", text: "pe-7s-prev"},
         {value: "pe-7s-mute", text: "pe-7s-mute"},
         {value: "pe-7s-power", text: "pe-7s-power"},
         {value: "pe-7s-medal", text: "pe-7s-medal"},
         {value: "pe-7s-portfolio", text: "pe-7s-portfolio"},
         {value: "pe-7s-like2", text: "pe-7s-like2"},
         {value: "pe-7s-plus", text: "pe-7s-plus"},
         {value: "pe-7s-left-arrow", text: "pe-7s-left-arrow"},
         {value: "pe-7s-play", text: "pe-7s-play"},
         {value: "pe-7s-key", text: "pe-7s-key"},
         {value: "pe-7s-plane", text: "pe-7s-plane"},
         {value: "pe-7s-joy", text: "pe-7s-joy"},
         {value: "pe-7s-photo-gallery", text: "pe-7s-photo-gallery"},
         {value: "pe-7s-pin", text: "pe-7s-pin"},
         {value: "pe-7s-phone", text: "pe-7s-phone"},
         {value: "pe-7s-plug", text: "pe-7s-plug"},
         {value: "pe-7s-pen", text: "pe-7s-pen"},
         {value: "pe-7s-right-arrow", text: "pe-7s-right-arrow"},
         {value: "pe-7s-paper-plane", text: "pe-7s-paper-plane"},
         {value: "pe-7s-delete-user", text: "pe-7s-delete-user"},
         {value: "pe-7s-paint", text: "pe-7s-paint"},
         {value: "pe-7s-bottom-arrow", text: "pe-7s-bottom-arrow"},
         {value: "pe-7s-notebook", text: "pe-7s-notebook"},
         {value: "pe-7s-note", text: "pe-7s-note"},
         {value: "pe-7s-next", text: "pe-7s-next"},
         {value: "pe-7s-news-paper", text: "pe-7s-news-paper"},
         {value: "pe-7s-musiclist", text: "pe-7s-musiclist"},
         {value: "pe-7s-music", text: "pe-7s-music"},
         {value: "pe-7s-mouse", text: "pe-7s-mouse"},
         {value: "pe-7s-more", text: "pe-7s-more"},
         {value: "pe-7s-moon", text: "pe-7s-moon"},
         {value: "pe-7s-monitor", text: "pe-7s-monitor"},
         {value: "pe-7s-micro", text: "pe-7s-micro"},
         {value: "pe-7s-menu", text: "pe-7s-menu"},
         {value: "pe-7s-map", text: "pe-7s-map"},
         {value: "pe-7s-map-marker", text: "pe-7s-map-marker"},
         {value: "pe-7s-mail", text: "pe-7s-mail"},
         {value: "pe-7s-mail-open", text: "pe-7s-mail-open"},
         {value: "pe-7s-mail-open-file", text: "pe-7s-mail-open-file"},
         {value: "pe-7s-magnet", text: "pe-7s-magnet"},
         {value: "pe-7s-loop", text: "pe-7s-loop"},
         {value: "pe-7s-look", text: "pe-7s-look"},
         {value: "pe-7s-lock", text: "pe-7s-lock"},
         {value: "pe-7s-lintern", text: "pe-7s-lintern"},
         {value: "pe-7s-link", text: "pe-7s-link"},
         {value: "pe-7s-like", text: "pe-7s-like"},
         {value: "pe-7s-light", text: "pe-7s-light"},
         {value: "pe-7s-less", text: "pe-7s-less"},
         {value: "pe-7s-keypad", text: "pe-7s-keypad"},
         {value: "pe-7s-junk", text: "pe-7s-junk"},
         {value: "pe-7s-info", text: "pe-7s-info"},
         {value: "pe-7s-home", text: "pe-7s-home"},
         {value: "pe-7s-help2", text: "pe-7s-help2"},
         {value: "pe-7s-help1", text: "pe-7s-help1"},
         {value: "pe-7s-graph3", text: "pe-7s-graph3"},
         {value: "pe-7s-graph2", text: "pe-7s-graph2"},
         {value: "pe-7s-graph1", text: "pe-7s-graph1"},
         {value: "pe-7s-graph", text: "pe-7s-graph"},
         {value: "pe-7s-global", text: "pe-7s-global"},
         {value: "pe-7s-gleam", text: "pe-7s-gleam"},
         {value: "pe-7s-glasses", text: "pe-7s-glasses"},
         {value: "pe-7s-gift", text: "pe-7s-gift"},
         {value: "pe-7s-folder", text: "pe-7s-folder"},
         {value: "pe-7s-flag", text: "pe-7s-flag"},
         {value: "pe-7s-filter", text: "pe-7s-filter"},
         {value: "pe-7s-file", text: "pe-7s-file"},
         {value: "pe-7s-expand1", text: "pe-7s-expand1"},
         {value: "pe-7s-exapnd2", text: "pe-7s-exapnd2"},
         {value: "pe-7s-edit", text: "pe-7s-edit"},
         {value: "pe-7s-drop", text: "pe-7s-drop"},
         {value: "pe-7s-drawer", text: "pe-7s-drawer"},
         {value: "pe-7s-download", text: "pe-7s-download"},
         {value: "pe-7s-display2", text: "pe-7s-display2"},
         {value: "pe-7s-display1", text: "pe-7s-display1"},
         {value: "pe-7s-diskette", text: "pe-7s-diskette"},
         {value: "pe-7s-date", text: "pe-7s-date"},
         {value: "pe-7s-cup", text: "pe-7s-cup"},
         {value: "pe-7s-culture", text: "pe-7s-culture"},
         {value: "pe-7s-crop", text: "pe-7s-crop"},
         {value: "pe-7s-credit", text: "pe-7s-credit"},
         {value: "pe-7s-copy-file", text: "pe-7s-copy-file"},
         {value: "pe-7s-config", text: "pe-7s-config"},
         {value: "pe-7s-compass", text: "pe-7s-compass"},
         {value: "pe-7s-comment", text: "pe-7s-comment"},
         {value: "pe-7s-coffee", text: "pe-7s-coffee"},
         {value: "pe-7s-cloud", text: "pe-7s-cloud"},
         {value: "pe-7s-clock", text: "pe-7s-clock"},
         {value: "pe-7s-check", text: "pe-7s-check"},
         {value: "pe-7s-chat", text: "pe-7s-chat"},
         {value: "pe-7s-cart", text: "pe-7s-cart"},
         {value: "pe-7s-camera", text: "pe-7s-camera"},
         {value: "pe-7s-call", text: "pe-7s-call"},
         {value: "pe-7s-calculator", text: "pe-7s-calculator"},
         {value: "pe-7s-browser", text: "pe-7s-browser"},
         {value: "pe-7s-box2", text: "pe-7s-box2"},
         {value: "pe-7s-box1", text: "pe-7s-box1"},
         {value: "pe-7s-bookmarks", text: "pe-7s-bookmarks"},
         {value: "pe-7s-bicycle", text: "pe-7s-bicycle"},
         {value: "pe-7s-bell", text: "pe-7s-bell"},
         {value: "pe-7s-battery", text: "pe-7s-battery"},
         {value: "pe-7s-ball", text: "pe-7s-ball"},
         {value: "pe-7s-back", text: "pe-7s-back"},
         {value: "pe-7s-attention", text: "pe-7s-attention"},
         {value: "pe-7s-anchor", text: "pe-7s-anchor"},
         {value: "pe-7s-albums", text: "pe-7s-albums"},
         {value: "pe-7s-alarm", text: "pe-7s-alarm"},
         {value: "pe-7s-airplay", text: "pe-7s-airplay"},*/
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    }
    ,
    async mountedContinued() {

      await ExecutorService.selectList().then((list) => {
        this.executorOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    }
    ,
    async onSubmit() {

      await this.setSendingDefault()

    }
    ,
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  }
  ,
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

